import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoanImagesComponent} from './loan-images.component';
import {AuthGuard} from '../shared/guards/auth.guard';
import {TermsGuard} from '../shared/guards/terms.guard';
import {LoansGuard} from '../shared/guards/loans.guard';

const routes: Routes = [
  {
    path: 'loan-images',
    component: LoanImagesComponent,
    canActivate: [AuthGuard, TermsGuard, LoansGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoanImagesRoutingModule { }
